import { render, staticRenderFns } from "./CheckPenaltiesByProtocolModal.vue?vue&type=template&id=6aec53e2&scoped=true&"
import script from "./CheckPenaltiesByProtocolModal.vue?vue&type=script&lang=js&"
export * from "./CheckPenaltiesByProtocolModal.vue?vue&type=script&lang=js&"
import style0 from "./CheckPenaltiesByProtocolModal.vue?vue&type=style&index=0&id=6aec53e2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aec53e2",
  null
  
)

export default component.exports